import { useEffect, useState } from "react";
import LoadingSection from "../helperComponents/LoadingSection";
import CustomLabel from "./CustomLabel";
import styled from "styled-components";
import { serverLine } from "../../controllers/network/serverLine";
// import { CSVLink } from "react-csv";
// import * as XLSX from "xlsx";
import XLSX from "xlsx-js-style";
import ExportFieldsSelector from "./ExportFieldsSelector";
import PrimaryButton from "../helperComponents/PrimaryButton";
import { useTranslation } from "react-i18next";
import preprocessDataForExport from "../../controllers/customControllerForCS/preprocessDataForExport";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
import goTo from "../../controllers/goTo";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 25px;
  padding-bottom: 50px;
  gap: 30px;
`;
const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 20px;
`;

const Hr = styled.div`
  height: 1px;
  width: 100%;
  opacity: 0.5;
  background-color: var(--element);
`;

const FieldsSelectionSection = styled.div`
  background-color: var(--surface2);
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--border);
`;

export default function ExporterPopup({
  path,
  title,
  selectedFields,
  autoDownloadExcel,
}) {
  const { t } = useTranslation();
  const [fieldsToExport, setFieldsToExport] = useState(
    selectedFields ? selectedFields : []
  );
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    serverLine.get(path).then((response) => {
      let newData = response.list;

      if (newData) {
        if (newData[0]) {
          if (!selectedFields) {
            setFieldsToExport(Object.keys(newData[0]));
          }
        }
      }

      let exportableData = preprocessDataForExport(newData);
      setData(exportableData);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    console.log("data loaded", data, autoDownloadExcel);
    if (data) if (autoDownloadExcel) doAutomaticDownload();
  }, [data]);

  function doAutomaticDownload() {
    console.log("doing auto download");

    if (autoDownloadExcel) {
      downloadExcel();
    }

    if (window.location.href.indexOf("formPage") !== -1) {
      goTo(-1)();
    }
  }

  if (loading) return <LoadingSection />;

  if (autoDownloadExcel) return <LoadingSection />;

  if (!data) return <LoadingSection />;

  let allHeaderValues = [];

  if (data[0]) {
    allHeaderValues = Object.keys(data[0]);
  }

  if (selectedFields) allHeaderValues = selectedFields;

  return (
    <Container>
      <Buttons>
        {/* <CSVLink
          data={dataToBeExported}
          headers={translatedHeader}
          filename={`${fileName}.csv`}
          className="btn"
        >
          <PrimaryButton style={{ pointerEvents: "none" }}>
            Export CSV
          </PrimaryButton>
        </CSVLink> */}
        <PrimaryButton onClick={downloadExcel}>Export Excel</PrimaryButton>
      </Buttons>

      <FieldsSelectionSection>
        <CustomLabel>Sélectionner</CustomLabel>
        <ExportFieldsSelector
          fieldsList={allHeaderValues}
          value={fieldsToExport}
          onChange={setFieldsToExport}
        />
      </FieldsSelectionSection>
    </Container>
  );

  function getFormattedDate() {
    const today = new Date();
    const day = today.getUTCDate();
    const month = today
      .toLocaleString("default", { month: "long" })
      .toLowerCase();
    const year = today.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }

  //remove some unicode characters that sometimes hide the text
  function cleanText(str) {
    if (!str) return str;
    if (!str.replace) return str;
    return str.replace(/[\u200B-\u200F\u2060\uFEFF]/g, "");
    //these characters get added by accident and they hide the values
  }

  function getExportFilePayload() {
    let dataToBeExported = [];

    for (let item of data) {
      let newItem = {};
      for (let key in item) {
        if (fieldsToExport.includes(key)) {
          let theValue = cleanText(item[key]);

          newItem[t(key)] = theValue;
        }
      }

      dataToBeExported.push(newItem);
    }

    let translatedHeader = fieldsToExport.map((item) => t(item));

    let fileName = `${title}${getFormattedDate()}`;

    return { translatedHeader, dataToBeExported, fileName };
  }

  // function exportPdf() {
  //   let { dataToBeExported, translatedHeader, fileName } =
  //     getExportFilePayload();
  //   const doc = new jsPDF();

  //   const body = dataToBeExported.map((row) =>
  //     translatedHeader.map((header) => row[header])
  //   );

  //   autoTable(doc, {
  //     head: [translatedHeader],
  //     body: body,
  //   });

  //   doc.save(fileName + ".pdf");
  // }

  function downloadExcelWithoutColors() {
    console.log("downloading excel");
    let { dataToBeExported, fileName, translatedHeader } =
      getExportFilePayload();
    const worksheet = XLSX.utils.json_to_sheet(dataToBeExported, {
      header: translatedHeader,
    }); // Convert JSON to worksheet

    //Sets appropriate column width
    worksheet["!cols"] = translatedHeader.map((field) => {
      const maxLength = Math.max(
        field.length,
        ...dataToBeExported.map((row) =>
          row[field] ? row[field].toString().length : 0
        )
      );
      return { wch: maxLength + 2 }; // +2 padding for readability
    });

    const workbook = XLSX.utils.book_new(); // Create new workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Export workbook
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  function parseDDMMYYYY(str) {
    const [dd, mm, yyyy] = str.split("/");
    return new Date(yyyy, mm - 1, dd); // JS Date: yyyy-mm-dd
  }

  function downloadExcel() {
    console.log("downloading excel");
    let { dataToBeExported, fileName, translatedHeader } =
      getExportFilePayload();

    const worksheet = XLSX.utils.json_to_sheet(dataToBeExported, {
      header: translatedHeader,
    });

    //Set date column as date data type
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      for (let C = 0; C < translatedHeader.length; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const field = translatedHeader[C];
        if (field.toLowerCase().indexOf("date") !== -1) {
          let cell = worksheet[cellAddress];
          if (cell && cell.v) {
            const jsDate =
              typeof cell.v === "string"
                ? parseDDMMYYYY(cell.v)
                : new Date(cell.v);

            worksheet[cellAddress] = {
              t: "d",
              v: jsDate,
              z: "dd/mm/yyyy", // ✅ force Excel to show as DD/MM/YYYY
            };
          }
        }
      }
    }

    // Set column widths
    worksheet["!cols"] = translatedHeader.map((field) => {
      const maxLength = Math.max(
        field.length,
        ...dataToBeExported.map((row) =>
          row[field] ? row[field].toString().length : 0
        )
      );
      return { wch: maxLength + 2 };
    });

    // Apply header style (blue background + white bold text)
    translatedHeader.forEach((field, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index }); // row 0 = header
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        fill: {
          fgColor: { rgb: "4472C4" }, // Blue
        },
        font: {
          bold: true,
          color: { rgb: "FFFFFF" }, // White text
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }
}
